// src/admin/pages/ChangeOwnPasswordModal.jsx
import React, { useState } from 'react';
import AdminModal from '../components/AdminModal.jsx';
import { changeOwnPassword } from '../adminApi.js';

const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: '8px',
  border: '1px solid rgba(0,0,0,0.12)', background: '#ffffff',
  color: '#1d1d1f', fontSize: '14px', boxSizing: 'border-box',
  outline: 'none', fontFamily: "'DM Sans', sans-serif",
};

const labelStyle = {
  display: 'block', color: '#6c6c6d', fontSize: '13px', marginBottom: '6px', fontWeight: 500,
};

export default function ChangeOwnPasswordModal({ open, onClose }) {
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (newPw !== confirmPw) { setError('Le password non coincidono'); return; }
    setError('');
    setLoading(true);
    try {
      await changeOwnPassword(currentPw, newPw);
      setSuccess(true);
      setCurrentPw('');
      setNewPw('');
      setConfirmPw('');
      setTimeout(() => { setSuccess(false); onClose(); }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    setCurrentPw('');
    setNewPw('');
    setConfirmPw('');
    setError('');
    setSuccess(false);
    onClose();
  }

  return (
    <AdminModal open={open} onClose={handleClose} title="Cambia password" width={420}>
      {success ? (
        <div style={{ padding: '16px', textAlign: 'center', color: '#10B981', fontSize: '14px' }}>
          Password aggiornata con successo
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Password attuale</label>
            <input type={showPw ? 'text' : 'password'} value={currentPw} onChange={e => setCurrentPw(e.target.value)} required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Nuova password</label>
            <input type={showPw ? 'text' : 'password'} value={newPw} onChange={e => setNewPw(e.target.value)} required minLength={8} style={inputStyle} />
            <span style={{ fontSize: '11px', color: '#6c6c6d', marginTop: '4px', display: 'block' }}>Minimo 8 caratteri</span>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Conferma nuova password</label>
            <input type={showPw ? 'text' : 'password'} value={confirmPw} onChange={e => setConfirmPw(e.target.value)} required minLength={8} style={inputStyle} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '12px', color: '#6c6c6d' }}>
              <input type="checkbox" checked={showPw} onChange={e => setShowPw(e.target.checked)} />
              Mostra password
            </label>
          </div>
          {error && (
            <div style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: '8px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', color: '#EF4444', fontSize: '13px' }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '10px', borderRadius: '8px', border: 'none',
              background: loading ? '#ccc' : '#E8002D', color: '#fff',
              fontSize: '14px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Aggiornamento...' : 'Cambia password'}
          </button>
        </form>
      )}
    </AdminModal>
  );
}
